(function(){
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  // Mobile navigation
  const menu = $('.sq-menu-btn'), mobileNav = $('.sq-mobile-nav');
  if(menu && mobileNav){ menu.addEventListener('click',()=>{ const open=mobileNav.classList.toggle('open'); menu.setAttribute('aria-expanded',open?'true':'false'); }); }

  // Wishlist (local to the browser, no customer account required)
  const wishKey='squero_wishlist';
  let wishes=[]; try{ wishes=JSON.parse(localStorage.getItem(wishKey)||'[]'); if(!Array.isArray(wishes)) wishes=[]; }catch(e){}
  function syncWishes(){
    $$('.sq-wishlist').forEach(btn=>{ const active=wishes.includes(btn.dataset.wishlist); btn.classList.toggle('is-active',active); btn.setAttribute('aria-pressed',active?'true':'false'); btn.textContent=active?'♥':'♡'; });
  }
  document.addEventListener('click',e=>{
    const btn=e.target.closest('.sq-wishlist'); if(!btn) return;
    e.preventDefault(); e.stopPropagation(); const h=btn.dataset.wishlist;
    wishes=wishes.includes(h)?wishes.filter(x=>x!==h):[...wishes,h];
    try{localStorage.setItem(wishKey,JSON.stringify(wishes));}catch(_){ }
    syncWishes();
  });
  syncWishes();

  // Cart drawer
  const drawer=$('[data-cart-drawer]');
  function money(cents){return new Intl.NumberFormat('it-IT',{style:'currency',currency:document.body.dataset.currency||'EUR'}).format(cents/100);}
  async function refreshCart(open=false){
    if(!drawer) return;
    try{
      const r=await fetch('/cart.js'); const cart=await r.json();
      const body=drawer.querySelector('[data-cart-body]'); const total=drawer.querySelector('[data-cart-total]');
      if(!cart.items.length){ body.innerHTML='<div class="sq-cart-empty">Il carrello è vuoto.<br><br><a href="/collections/all">CONTINUA LO SHOPPING</a></div>'; }
      else body.innerHTML=cart.items.map(item=>`<div class="sq-mini-item"><a href="${item.url}">${item.image?`<img src="${item.image}&width=180" alt="">`:''}</a><div><a href="${item.url}">${item.product_title}</a><small>${item.variant_title && item.variant_title!=='Default Title'?item.variant_title+'<br>':''}Quantità: ${item.quantity}</small></div><strong>${money(item.final_line_price)}</strong></div>`).join('');
      if(total) total.textContent=money(cart.total_price);
      $$('.sq-cart-count').forEach(el=>el.textContent=cart.item_count);
      if(open){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('sq-no-scroll');}
    }catch(e){}
  }
  function closeCart(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('sq-no-scroll');}
  document.addEventListener('click',e=>{
    const cartLink=e.target.closest('.sq-cart-link');
    if(cartLink && drawer){e.preventDefault();refreshCart(true);return;}
    if(e.target.closest('[data-cart-close]')) closeCart();
  });
  window.addEventListener('squero:cart-updated',()=>refreshCart(true));
})();
